module.exports = __webpack_public_path__ + "media/images/default/homepage/experience/hospital-307b88259cf00bff5cf016a2d9f613c4.svg";